import { Input, InputProps, InputRef } from "antd";
import { useEffect, useRef } from "react";
import { PlaceData, getPlaceData } from "./googlePlacesAutoCompleteModel";
import GoogleMapsWrapper from "../maps/GoogleMapsWrapper";

const autocompleteOptions: google.maps.places.AutocompleteOptions = {
  fields: ['address_components', 'geometry'],
  types: ['address']
}

type Props = InputProps & {
  apiKey: string
  onPlaceData: (data: PlaceData) => void
}

const GooglePlacesAutoCompleteInput = (inputProps: Props) => {
  const autoCompleteRef = useRef<any>();
  const inputRef = useRef<InputRef>(null);

  const { onPlaceData, apiKey, ...filteredInputProps} = inputProps

  const onPlaceDataRef = useRef(onPlaceData)
  onPlaceDataRef.current = onPlaceData

  useEffect(() => {
    if (inputRef.current && inputRef.current.input) {
      autoCompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current.input, autocompleteOptions)
      autoCompleteRef.current.addListener("place_changed", async function () {
        const place = await autoCompleteRef.current.getPlace();
        const data = getPlaceData(place.address_components, place.geometry);
        onPlaceDataRef.current(data);
       });
    }

    return () => {
      if (autoCompleteRef.current) {
        autoCompleteRef.current.unbindAll();
      }
    }
  }, [])

  return <Input ref={inputRef} {...filteredInputProps} />
}

const WrappedGooglePlacesAutoCompleteInput = (props: Props) => {
return <GoogleMapsWrapper apiKey={props.apiKey}>
  <GooglePlacesAutoCompleteInput {...props} />
</GoogleMapsWrapper>
}

export default WrappedGooglePlacesAutoCompleteInput
